// extracted by mini-css-extract-plugin
export default {"button":"styles_button__gwadH","danger":"styles_danger__oM4eF"};